import React from "react";
import { Link, generatePath, useNavigate } from "react-router-dom";

import I176TextLogo from "assets/icons/I176TextLogo";

import { Header, NavMenu } from "components/Layout";

import SearchControl from "./SearchControl";
import ConfirmPopup from "components/ConfirmPopup";
import withGlobalPopup from "components/Popup/withGlobalPopup";
import type { GlobalPopupProps } from "components/Popup/withGlobalPopup";

import ROUTES from "navigation/routes";

import { ControlsContainer, ControlGroup, IconWrapper } from "./styles";
import I24Logout from "assets/icons/I24Logout";
import styleConst from "constants/style";
import AuthStore from "stores/AuthStore";
import { withTranslation, WithTranslation } from "react-i18next";

const NAVIGATION_MENU_ITEMS = [
  {
    titleKey: "menu.today",
    route: ROUTES.TODAY,
    rootRoute: ROUTES.TODAY,
  },
  {
    titleKey: "menu.workouts",
    route: ROUTES.WORKOUT,
    rootRoute: ROUTES.WORKOUT,
  },
  {
    titleKey: "menu.favorites",
    route: ROUTES.WORKOUT_FAVORITES,
    rootRoute: ROUTES.WORKOUT_FAVORITES,
  },
  {
    titleKey: "menu.calendar",
    route: ROUTES.CALENDAR,
    rootRoute: ROUTES.CALENDAR,
  },
];

type Props = {
  disabled?: boolean;
  openPopup: (options: {
    key: string;
    exitButtonColor?: string;
    render: ({ close }: { close: () => void }) => React.ReactNode;
  }) => void;
  t: (key: string) => string;
} & GlobalPopupProps &
  WithTranslation;

const AppHeader: React.FC<Props> = props => {
  const navigate = useNavigate();

  const onLogoutPress = () => {
    const { openPopup } = props;
    const t: (key: string) => string = props.t;

    openPopup({
      key: "ConfirmPopup",
      exitButtonColor: styleConst.colors.black25,
      render: ({ close }: { close: () => void }) => (
        <ConfirmPopup
          onClose={close}
          onAccept={logout}
          title={t("areYouSureLogOut")}
        />
      ),
    });
  };

  const logout = () => {
    navigate(generatePath(ROUTES.SIGN_IN));
    AuthStore.logout();
  };

  const { disabled } = props;
  const t: (key: string) => string = props.t;
  return (
    <Header
      leftContent={
        <Link to={ROUTES.TODAY}>
          <I176TextLogo />
        </Link>
      }
      centerContent={
        <NavMenu
          items={NAVIGATION_MENU_ITEMS.map(item => ({
            ...item,
            title: t(item.titleKey),
          }))}
        />
      }
      rightContent={
        <ControlsContainer>
          <ControlGroup>
            <IconWrapper>
              <SearchControl />
            </IconWrapper>
          </ControlGroup>

          <ControlGroup>
            <IconWrapper onClick={onLogoutPress}>
              <I24Logout />
            </IconWrapper>
          </ControlGroup>
        </ControlsContainer>
      }
      isOverlay
      disabled={disabled}
    />
  );
};

export default withGlobalPopup(withTranslation()(AppHeader));
